export default {
  component: () => import('./page.vue'),
  path: '/invitation/:id',
  name: 'invitation',
  alias: ['/invitation-app/:id'],
  meta: {
    title: '查看邀请',
    auth: true,
    wechat: {
      AppMessageShare: false,
      TimelineShare: false,
    },
  },
};
